import Vue from 'vue'
import Vue18n from 'vue-i18n'

Vue.use(Vue18n)